import type { ApiClient } from "@/lib/api";

export const deleteMcpGateway = async (options: {
  client: ApiClient;
  id: string;
}) => {
  const { client, id } = options;
  const { data } = await client.delete(`/gateways/${id}`);
  return data;
};
